@if (notify) {
  <div
    class="notification-card"
    [class.notification-card_new]="isModalMode"
    [class.notification-card_modal]="isModalMode"
    [class.notification-card_border]="!isModalMode"
    [class.notification-card_disabled]="notify.entity.removed || isModalMode"
    (click)="goToEntity()"
  >
    @if (isModalMode) {
      <div class="notification-card__indicator"></div>
    }
    <div
      class="notification-card__avatar"
      [class.notification-card__avatar_border]="!notify.author.avatarPreview"
    >
      <app-image [img]="notify.author.avatarPreview | addBaseUrl"></app-image>
      @if (notify.type === repliesResultTypes.like) {
        <img
          src="./assets/images/icons-svg/notifications/like.svg"
          class="notification-card__type-icon"
        />
      }
      @if (notify.type === repliesResultTypes.comment) {
        <img
          src="./assets/images/icons-svg/notifications/comment.svg"
          class="notification-card__type-icon"
        />
      }
    </div>
    <div class="notification-card__content">
      <div class="notification-card__name">
        <app-text
          [text]="notify.author | getFullName"
          [textType]="TextType.base"
          [textSize]="TextSizes.h4Name"
          (click)="goToUser($event)"
        ></app-text>
        @if (currentUser$ | async; as currentUser) {
          @if (notify.type === repliesResultTypes.comment) {
            <app-text
              class="notification-card__type-text"
              [text]="notify | notificationReply"
              [textType]="TextType.base"
              [textSize]="TextSizes.mobInput"
            ></app-text>
          }
          @if (notify.type !== repliesResultTypes.comment) {
            <app-text
              class="notification-card__type-text"
              [text]="notify | notificationText: currentUser.id"
              [textType]="TextType.base"
              [textSize]="TextSizes.mobInput"
            ></app-text>
          }
        }
      </div>
      @if (notificationText || notificationReplyText.length) {
        <div class="notification-card__text">
          @if (notificationText) {
            <app-text
              [text]="notificationText"
              [textType]="TextType.base"
              [textSize]="TextSizes.notification"
            ></app-text>
          }
          @if (notificationReplyText.length) {
            <app-text [textType]="TextType.base" [textSize]="TextSizes.notification">
              <span>{{ notificationReplyText[0] }}</span
              >{{ notificationReplyText[1] }}
            </app-text>
          }
        </div>
      }
      <div class="notification-card__info">
        <app-text [textType]="TextType.base" [textSize]="TextSizes.h3Body">
          <span>{{ notify.createDate | dateFormat }}</span>
          @if (
            !notify.entity.replyForCommentText &&
            notify.entity.type === notificationTypes.post &&
            notify.type === repliesResultTypes.comment
          ) {
            {{ notify.entity.msg ? 'к записи:' : 'к записи' }} <br /><span>{{
              notify.entity.msg
            }}</span>
          }
          @if (notify.entity.replyForCommentText) {
            {{ 'на комментарий' }}: <br /><span>{{ notify.entity.replyForCommentText }}</span>
          }
        </app-text>
      </div>
    </div>
    <div
      class="notification-card__preview"
      [class.notification-card__preview_centered]="showFileIcon || showPollIcon"
    >
      @if (showImageIcon) {
        <div class="notification-card__image">
          <app-image [img]="notify.entity.imagePreview | addBaseUrl"></app-image>
          @if (showCounter) {
            <div class="notification-card__overlay">
              <app-text
                [text]="'+' + (notify.entity.imageCount - 1 + '')"
                [textType]="TextType.base"
                [textSize]="TextSizes.h4Name"
              ></app-text>
            </div>
          }
        </div>
      }
      @if (showFileIcon) {
        <div class="notification-card__file">
          <app-image
            [img]="
              notify.entity.postFileName | getFilePicture: (platform$ | async) !== Platform.desktop
            "
          ></app-image>
        </div>
      }
      @if (showPollIcon) {
        <div class="notification-card__poll">
          <app-image img="/assets/images/icons-svg/poll.svg"></app-image>
        </div>
      }
    </div>
  </div>
}
